import styled from 'styled-components';
import theme from 'styled-theming';
var FeatureHeader = styled.div.withConfig({
  displayName: "FeatureHeaderstyles__FeatureHeader",
  componentId: "sc-auf43c-0"
})(["position:relative;width:100%;"]);
var CloseButton = styled.div.withConfig({
  displayName: "FeatureHeaderstyles__CloseButton",
  componentId: "sc-auf43c-1"
})(["z-index:3;position:absolute;top:0;right:0;padding:var(--dentsu-spacing-20);"]);
var Surface = styled.div.withConfig({
  displayName: "FeatureHeaderstyles__Surface",
  componentId: "sc-auf43c-2"
})(["position:absolute;top:0;left:0;bottom:0;width:66vw;background-color:", ";background-image:linear-gradient( 45deg,rgba(255,255,255,0.05) 12.5%,rgba(255,255,255,0) 12.5%,rgba(255,255,255,0) 50%,rgba(255,255,255,0.05) 50%,rgba(255,255,255,0.05) 62.5%,rgba(255,255,255,0) 62.5%,rgba(255,255,255,0) 100% );background-image:", ";background-size:5.66px 5.66px;background-repeat:repeat;z-index:1;"], theme('level', {
  one: 'var(--dentsu-color-n750)',
  two: 'var(--dentsu-color-n150)'
}), theme('level', {
  two: 'none'
}));
export var Styled = {
  FeatureHeader: FeatureHeader,
  CloseButton: CloseButton,
  Surface: Surface
};